module.exports = __webpack_public_path__ + "media/icons/opony-title-437d36a5.png";